import {useCallback} from 'react';
import {ApiClientService} from '@dofleini/security';
import {useMutation, useQueryClient} from 'react-query';
import ForgotPassword from '../services/Frogot.api.service';

const errors = {
  'Password history error': 'recovery.historyError',
  'Invalid data provided.': 'recovery.notfound',
};

export const useResetPassword = () => {
  const queryClient = useQueryClient();
  const {mutateAsync, isLoading, isError, data, error} = useMutation(ForgotPassword.finish);

  const onFinish = useCallback(async (body) => {
    try {
      const {data} = await mutateAsync(body);
      ApiClientService.setToken(data.accessToken, body.remember);
      if (data.space)
        ApiClientService.setSpace(data.space);
      await queryClient.invalidateQueries('user-me');
    } catch {
      //ignoring
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let errorMessage;

  if (error) {
    errorMessage = !error.status ? 'login.network' : 'login.generalError';
    console.log(error?.response?.data?.message);
    if (errors[error?.response?.data?.message])
      errorMessage = errors[error.response.data.message];
  }

  return {
    onFinish,
    isLoading,
    isError,
    data,
    error: errorMessage
  };
};
